export default class PhoneNumber {
    id: number;
    number: string;
    extension: string;
    typeId: number;
    isPrimary: boolean;
}



// WEBPACK FOOTER //
// ./src/models/PhoneNumber.ts